export enum ProfileAction {
  AddNumber = 'AddNumber',
  EditPeferredNumber = 'EditPeferredNumber',
  EditNonPeferredNumber = 'EditNonPeferredNumber',
  ChangePreferredNumber = 'ChangePreferredNumber',
  AddAddress = 'AddAddress',
  EditPeferredAddress = 'EditPeferredAddress',
  EditNonPeferredAddress = 'EditNonPeferredAddress',
  ChangePreferredAddress = 'ChangePreferredAddress',
  ChangeEmail = 'ChangeEmail',
}
